import * as React from 'react';

const ReceiptFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <defs>
            <path
                id="receipt-fill_svg__24_small_receipt_fill-a"
                d="M0 0v1h2v19l2.67-1.525L7.338 20l2.67-1.525L12.664 20l2.664-1.525L17.983 20 18 1H20V0H0zm6 6h8v1H6V6zm0 3h8v1H6V9zm0 3h8v1H6v-1z"
            />
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(2 2)">
            <mask id="receipt-fill_svg__24_small_receipt_fill-b" fill="#fff">
                <use xlinkHref="#receipt-fill_svg__24_small_receipt_fill-a" />
            </mask>
            <use
                fill="#45494E"
                xlinkHref="#receipt-fill_svg__24_small_receipt_fill-a"
            />
            <g mask="url(#receipt-fill_svg__24_small_receipt_fill-b)">
                <path fill="#000" d="M-2-2h24v24H-2z" />
            </g>
        </g>
    </svg>
);

ReceiptFillSvg.displayName = 'ReceiptFillSvg';
export default ReceiptFillSvg;
